(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/prolongwager-extended.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/prolongwager-extended.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.ProlongWagerExtended = Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.prolongwager_extended(data);
    },
    events: {
      'click .js-prolong-btn': 'onProlong',
      'click .js-prolong-edit-btn': 'onProlongEdit',
      'click .btn-prolong-correct': 'goToCorrection'
    },
    initialize: function() {
      this.coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
      this.listenTo(
        this.coupon,
        'wager:paySuccess',
        this.onPaymentSuccess,
        this
      );
    },
    log: new svs.core.log.Logger('svs.maltipset.views.ProlongWager'),
    onProlongEdit: function() {
      if (this.coupon.isEnabled()) {
        this.model.prolongEdit();
        try {
          window.location.href = svs.utils.url.removeQueryString() + '/spela';
        } catch (e) {
          this.log.error(e.message);
        }
      } else {
        this.showNoOpenDrawAlert();
      }
    },
    onProlong: function() {
      if (this.coupon.isEnabled()) {
        this.prolong();
      } else {
        this.showNoOpenDrawAlert();
      }
    },
    prolong: function() {
      this.model.setProlongData();
      this.betslip = new svs.app.betslipv2.FlyingBetslip({
        model: new Backbone.Model({})
      });
      this.betslip.getRegion('betslipContent').show(new svs.maltipset.views.BetslipProlong({
        model: this.model,
        coupon: this.coupon
      }));
      this.betslip.getRegion('betslipFooter').show(new svs.maltipset.views.BetslipPaymentFooter({
        model: this.coupon
      }));
    },
    showNoOpenDrawAlert: function() {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'help-2',
        title: 'Det finns tyvärr ingen öppen omgång på Måltipset',
        actions: [
          {
            title: 'Okej'
          }
        ]
      }));
    },
    onPaymentSuccess: function() {
      svs.maltipset.collections.coupons
        .getCurrentCoupon()
        .unset('prolongWager');
      if (this.betslip) {
        this.betslip.destroy();
      }
    },
    goToCorrection: function() {
      var self = this;
      var goToMyGames = function() {
        var url =
            window.location.href +
            '/mina-spel/' +
            self.model.get('wagerId') +
            '/' +
            self.model.get('currentDrawNumber');
        url += self.model.get('currentAddonDrawNumber') ?
            '/' + self.model.get('currentAddonDrawNumber') :
            '';
        window.location.href = url;
      };
      svs.components.Modal.hide();
      if (svs.core.detect.formfactor.mobile()) {
        setTimeout(function() {
          goToMyGames();
        }, 130);
      } else {
        goToMyGames();
      }
    }
  });
})(Backbone, _, svs);


 })(window);